module.exports = __webpack_public_path__ + "static/media/24UHCHR15.4063fb21.jpg";